import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  qty: {
    alignItems: 'center',
    border: `1px solid ${theme.palette.grey1}`,
    borderRadius: 20,
    color: theme.palette.darkGrey,
    display: 'flex',
    fontSize: 14,
    fontWeight: 600,
    height: 36,
    justifyContent: 'center',
    letterSpacing: '0.1px',
    lineHeight: '20px',
    width: 130,
    [theme.breakpoints.down('lg')]: {
      height: 34,
      width: 96,
    },
    [theme.breakpoints.down('md')]: {
      height: 24,
      width: 96,
    },
  },
}));
